import { Component, Input, inject, input } from '@angular/core';
import { ChartData } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
import { BarChartComponent } from '../../../shared/components/charts/bar-chart/bar-chart.component';

@Component({
    selector: 'app-single-tenant-overview',
    template: `
    @if (benefits().length) {
      <div class="row mb-3">
        @if (data) {
          <div class="col-12 col-md-12">
            <app-bar-chart [data]="data" [configTitle]="title()"></app-bar-chart>
          </div>
        }
      </div>
    }
    `,
    styles: [
        `
          .benefit-graph-overview {
            max-height: 350px;
            overflow-y: auto;
          }
        `,
    ],
    imports: [BarChartComponent]
})
export class SingleTenantOverviewComponent {
  private readonly translateService = inject(TranslateService);


  @Input() data!: ChartData<'bar'>;
  readonly benefits = input.required<any[]>();

  readonly title = input({
    text: this.translateService.instant('DASHBOARD.TREND_OVERVIEW'),
    display: true,
    font: {
        size: 24,
    },
});
}
